import React from 'react';
import { 
    Card,
    Table,
    Button,
    TableBody,
    TableContainer,
    Box,
    LinearProgress,
    Grid
} from '@mui/material';

import PageLayout from '../../../layouts/PageLayout';
import usePatientListPage from './usePatientListPage';
import TableHeadCustom from '../../../components/table/TableHeadCustom';
import PatientTableRow from './components/PatientTableRow';
import TableNoData from '../../../components/table/TableNoData';
import TablePaginationCustom from '../../../components/table/TablePaginationCustom';
import TableActionBar from '../../../components/table/TableActionBar';

const TABLE_HEAD = [
    { id: 'id', label: 'ID', align: 'left' },
    { id: 'name', label: 'Nombre', align: 'left' },
    { id: 'rol', label: 'Rol', align: 'left' },
    { id: 'email', label: 'Email', align: 'left' },
    { id: 'status', label: 'Teléfono', align: 'left' },
    { id: '', label: '', align: '' },
  ];
  

const PatientListPage = () => {

    const {actions, data, system, modals, tableController} = usePatientListPage()

    const {table_config, count, users} = data

    const page = table_config.offset
    const rowsPerPage = table_config.limit

    const dense = true
    const denseHeight = dense ? 52 : 72;
    const isNotFound = !users.length

    const {selected} = data
 
    return ( 
        <PageLayout
            title='Pacientes'
            title_seo='Pacientes | Celu'
            loading={system.loading}
        >
            <div>
                <Box sx={{marginBottom:2, marginTop:2}}>
                    <Grid container spacing={2}>
                        <Grid item xs>
                            <TableActionBar onRequestSearch={actions.onRequestSearch}/>
                        </Grid>
                        {/*<Grid item>
                            <FilterButton label='Rol' 
                            options={[{id:-1, value:-1, label:'Todos'}, ...data.roles]} 
                            selected={tableController.filter.role.value} 
                            onChange={(val) => tableController.onUpdateFilterValue('role', val)}/>
            </Grid>*/}

                    </Grid>
                </Box>
                {(system.sending) && <Box sx={{marginBottom:2}}><LinearProgress /></Box> }
                <Card sx={{overflow:'auto'}}>
                    
                    <TableContainer sx={{position: 'relative', overflow: 'unset'  }}>
                        
                            <Table stickyHeader size={'small'} sx={{ minWidth: 800}}>
                                <TableHeadCustom
                                    order={table_config.order}
                                    orderBy={table_config.order_by}
                                    headLabel={TABLE_HEAD}
                                    rowCount={count}
                                    numSelected={0}
                                    onSort={actions.onSort}
                                />

                                <TableBody>
                                {users.map((row) => (
                                    <PatientTableRow
                                    key={`user-item-${row?.id_user}`}
                                        row={row}
                                    //selected={selected.includes(row.id)}
                                        onSelectRow={() => actions.onSelectRow(row)}
                                        onDeleteRow={() => actions.onDeleteRow(row)}
                                        onEditRow={() => actions.onEditRow(row)}
                                    />
                                ))}

                               {/*<TableEmptyRows height={denseHeight} emptyRows={emptyRows(rowsPerPage, users.length)} />*/}

                                <TableNoData isNotFound={isNotFound} />
                                </TableBody>
                            </Table>
                    </TableContainer>

                    
                </Card>
                <Box sx={{marginTop:2}}>
                    <TablePaginationCustom      
                        tableFilter={table_config}               
                        total={count}
                        onChangePagination={actions.onChangePagination}
                    />
                </Box>
                
                
            </div>
        </PageLayout>
     );
}
 
export default PatientListPage;